var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatavatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(255, 106, 20)"
    },
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "rgba(0, 0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.034279, 0, 0, 0.03531, 2.914762, 1.101826)",
    style: {}
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 595.3,
    height: 595.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595.3,
    height: 595.3,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.5,410.8c-50.9,0-92.2,41.3-92.2,92.2c0,50.9,41.3,92.2,92.2,92.2c50.9,0,92.2-41.3,92.2-92.2 c0-13.2-2.8-25.7-7.8-37.1l139.3-117.9c14.5,9.5,31.9,15.1,50.5,15.1c50.9,0,92.2-41.3,92.2-92.2c0-50.9-41.3-92.2-92.2-92.2 c-18.6,0-36,5.5-50.5,15.1l-76.2-64.5c5-11.3,7.8-23.9,7.8-37.1c0-50.9-41.3-92.2-92.2-92.2c-50.9,0-92.2,41.3-92.2,92.2 c0,50.9,41.3,92.2,92.2,92.2c18.6,0,36-5.5,50.5-15.1l76.2,64.4c-5,11.4-7.8,23.9-7.8,37.1c0,13.2,2.8,25.8,7.8,37.1L211,425.9 C196.5,416.4,179.1,410.8,160.5,410.8",
    style: {
      clipPath: "url(#SVGID_2_)",
      clipRule: "evenodd",
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatavatar);
export default __webpack_public_path__ + "static/media/chatavatar.5f2013a76abcfaee5acca58bb75ad53a.svg";
export { ForwardRef as ReactComponent };